module.exports = __webpack_public_path__ + "static/media/arrowRightLastItem.eb3e5936.svg";